import { render, staticRenderFns } from "./ExpensesCard.vue?vue&type=template&id=ee9ca9e6&"
import script from "./ExpensesCard.vue?vue&type=script&lang=js&"
export * from "./ExpensesCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports